import firebase from 'firebase';

const config = {
	apiKey: "AIzaSyCX67CHeL0NW-aTvRLDzT1lnz0Ei5W76kI",
	authDomain: "tally-f3cb1.firebaseapp.com",
	databaseURL: "https://tally-f3cb1.firebaseio.com",
	projectId: "tally-f3cb1",
	storageBucket: "tally-f3cb1.appspot.com",
	messagingSenderId: "670579630530"
};

firebase.initializeApp(config);

export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js